define('forum/account/canned-responses', ['canned-responses'], function(cannedResponses) {
	var settings = {};

	settings.init = cannedResponses.init;
	return settings;
});